import BasicColorsDeckIMG from "../../assets/DeckCards/Colors/BasicColorsDeckIMG.png";
import OtherColorsDeckIMG from "../../assets/DeckCards/Colors/OtherColorsDeckIMG.png";


//색깔
export const ColorsDeckFace = [

    {
        id: "basic_colors",
        Title: "Basic Colors",
        Description: "Learn basic colors!",
        Difficulty: "Beginner 2",
        Image: BasicColorsDeckIMG,
        Link: "/BasicColorsDeck",
        cssId: "basic-colors-ID"
    },

        {
        id: "other_colors",
        Title: "Other Colors",
        Description: "Learn more colors!",
        Difficulty: "Beginner 2",
        Image: OtherColorsDeckIMG,
        Link: "/OtherColorsDeck",
        cssId: "other-colors-ID"
    }


]